import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { formatMoney, RoundingStrategy } from "@faire/web--source/common/money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";

import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

export const useFormattedTerms = (terms: IFaireMoney) => {
  const { localeKey } = useLocalization();
  const { isEurope } = useRetailerStore(["isEurope"]);

  const isEnglish = (localeKey?.language ?? Language.ENG) === Language.ENG;
  const shouldUseCompact = isEnglish && !isEurope;

  return formatMoney({
    money: terms,
    compact: shouldUseCompact,
    roundingStrategy: RoundingStrategy.DROP_CENTS,
  });
};
